import { render, staticRenderFns } from "./PersonaReport.vue?vue&type=template&id=1f5a43c6&scoped=true"
import script from "./PersonaReport.vue?vue&type=script&lang=ts"
export * from "./PersonaReport.vue?vue&type=script&lang=ts"
import style0 from "./PersonaReport.vue?vue&type=style&index=0&id=1f5a43c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a43c6",
  null
  
)

export default component.exports